

    //<Checkbox class="mt-4" :fieldAddress="[compIndex, 'askForAdditional', 'profilePicture']" text="Profile picture" />

    import StepContainer from './common/StepContainer.vue'
    import Vue from 'vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import TipsSelector from './common/TipsSelector.vue'    
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'    
    import RatingScaleSelector from './common/RatingScaleSelector.vue'    
    import Checkbox from './common/Checkbox.vue'

    export default Vue.extend({
        //--------
        data () {
            return {
                
            }
        },
        mixins: [HelperMethods, RepeatingStepLogic],
        //--------
        created (): void {            

        },
        //---------
        props: {
            compIndex: Number            
        },
        //--------
        components: {
            surveystep: StepContainer,
            TextInputButton,
            TextAreaButton,
            TipsSelector,
            ContentDisplayClosed,
            RatingScaleSelector,
            Checkbox
        },
        //--------
        methods: {


            }
        })
